<template>
    <div class="navleft-db">
      <div class="navt">
        <div class="navttit">
          党建工作
        </div>
        <ul class="navlist">
          <li class="cur"><a href="">党建园地</a></li>
          <li class=""><a href="">党建园地</a></li>
          <li class=""><a href="">纠风工作</a></li>
          <li class=""><a href="">文明创建</a></li>
          <li class=""><a href="">安全生产</a></li>
          <li class=""><a href="">青年文明号</a></li>
          <li class=""><a href="">政策法规</a></li>
        </ul>
      </div>
      <div class="navb">
        <div class="navbt">
          <span>科室导航</span>
          <a href="" class="more floatR">更多>></a>
        </div>
        <div class="navbcont">
          <ul>
            <li><a href="">妇产科</a> </li>
            <li><a href="">肛肠科</a> </li>
            <li><a href="">急诊科</a> </li>
            <li><a href=""> 口腔科</a> </li>
            <li><a href="">肺病科 </a> </li>
            <li><a href="">外一科</a> </li>
            <li><a href="">骨伤科</a> </li>
            <li><a href="">针灸科 </a> </li>
            <li><a href="">儿  科</a> </li>
            <li><a href=""> 皮肤科</a> </li>
            <li><a href="">心病科 </a> </li>
            <li><a href="">耳鼻喉科</a> </li>
            <li><a href="">检验科</a> </li>
            <li><a href="">肿瘤微创科 </a> </li>
            <li><a href="">重症监护室</a> </li>
            <li><a href=""> 脾胃病科</a> </li>
            <li><a href="">内分泌科 </a> </li>
            <li><a href="">肾病科</a> </li>
            <li><a href="">健康体检中心</a> </li>
            <li><a href="">外二科 </a> </li>
            <li><a href="">脑病科</a> </li>
            <li><a href=""> 治未病科</a> </li>
            <li><a href="">推拿科 </a> </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "tNavleft"
    }
</script>

<style lang="scss">
.navleft-db{
  width: 220px;
  margin-left: 11px;
  float: left;
  .navt{
    margin-bottom: 60px;
    .navttit{
      width: 220px;
      height: 70px;
      background: url("../../images/zyy/leftt.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 70px;
      font-size: 24px;
      color: #fff;
      margin-bottom: 5px;
    }
    .navlist{
      li{
        width: 220px;
        height: 40px;
        color: #fff;
        line-height: 40px;
        background: url("../../images/zyy/leftc.png") no-repeat;
        background-size: 100%;
        margin-bottom: 5px;
        text-align: center;
        font-size: 16px;
        &.cur{
          background: url("../../images/zyy/cur.png") no-repeat;
          a{
            color: #fff;
          }
        }
        &:hover{
          background: url("../../images/zyy/cur.png") no-repeat;
          a{
            color: #fff;
          }
        }
      }
    }
  }
  .navb{
    width: 220px;
    border: 1px solid #ddd;
    .navbt{
      width: 100%;
      height: 47px;
      background: url("../../images/zyy/navbg.png") no-repeat;
      span{
        display: inline-block;
        background: #fff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        font-size: 18px;
        width: 100px;
        height: 44px;
        margin-left: 5px;
        line-height: 44px;
        margin-top: 3px;
        text-align: center;
      }
      .more{
        color: #fff;
        line-height: 45px;
        margin-right: 3px;
        font-size: 16px;
      }
    }
    .navbcont{
      ul{
        margin: 10px 0 5px;
        overflow: hidden;
        li{
          width: 107px;
          margin:2px 1px;
          height: 36px;
          background: url("../../images/zyy/fckbg.png") no-repeat;
          background-size: 100%;
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          float: left;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/navleft.vue